<template>
    <div class="container app-description">
        <h2 class="text-center">Descubre lo que estamos preparando para ti</h2>
        <div class="row mt-5">
            <div class="col">
                <div class="card left" v-on:mouseover="toolHover(0)" v-on:mouseleave="leave">
                    <a href="#tools-0" v-smooth-scroll>
                        <h4>Jabruta online</h4>
                        <p>{{$store.state.tools[0].mobileText}}</p>
                        <div class="icon">
                            <img :src="require('../assets/images/hands.svg')" class="img-fluid">
                        </div>
                    </a>
                </div>
                <div class="card left" v-on:mouseover="toolHover(1)" v-on:mouseleave="leave">
                    <a href="#tools-1" v-smooth-scroll>
                        <h4>Consulta al Rab</h4>
                        <p>{{$store.state.tools[1].mobileText}}</p>
                        <div class="icon">
                            <img :src="require('../assets/images/chat.svg')" class="img-fluid">
                        </div>
                    </a>
                </div>
                <div class="card left" v-on:mouseover="toolHover(2)" v-on:mouseleave="leave">
                    <a href="#tools-2" v-smooth-scroll>
                        <h4>Coaching</h4>
                        <p>{{$store.state.tools[2].mobileText}}</p>
                        <div class="icon">
                            <img :src="require('../assets/images/coaching.svg')" class="img-fluid">
                        </div>
                    </a>
                </div>
            </div>
            <div class="col">
                <div class="frame">
                    <img :src="require('../assets/images/BORDER.png')" class="img-fluid jabrutouch-img-shadow"/>
                    <img :src="require('../assets/images/MENUONLY.png')" class="phone-menu"/>
                    <transition name="slide" mode="out-in">
                        <div v-if="showTool" :style="{backgroundImage: 'url(' + require('../assets/images/' + mainBackground) +')'}" class="img"></div>
                    </transition>
                    <transition v-for="(tool, index) in $store.state.tools" :key="index" name="slide" mode="out-in">
                        <div v-if="tool.showImg" :style="{backgroundImage: 'url(' + require('../assets/images/participa/' + index + '.png')}" class="tool-img"></div>
                    </transition>
                </div>
                <div class="card bottom" v-on:mouseover="toolHover(6)" v-on:mouseleave="leave">
                    <a href="#tools-6" v-smooth-scroll>
                        <h4>Concordatsia</h4>
                        <p>{{$store.state.tools[6].mobileText}}</p>
                        <div class="icon">
                            <img :src="require('../assets/images/search.svg')" class="img-fluid">
                        </div>
                    </a>
                </div>
            </div>
            <div class="col">
                <div class="card right" v-on:mouseover="toolHover(3)" v-on:mouseleave="leave">
                    <a href="#tools-3" v-smooth-scroll>
                        <h4>MyJabrutouch</h4>
                        <p>{{$store.state.tools[3].mobileText}}</p>
                        <div class="icon">
                            <img :src="require('../assets/images/my-jabrutouch.svg')" class="img-fluid">
                        </div>
                    </a>
                </div>
                <div class="card right" v-on:mouseover="toolHover(4)" v-on:mouseleave="leave">
                    <a href="#tools-4" v-smooth-scroll>
                        <h4>Otsar Hajojmá</h4>
                        <p>{{$store.state.tools[4].mobileText}}</p>
                        <div class="icon">
                            <img :src="require('../assets/images/book.svg')" class="img-fluid">
                        </div>
                    </a>
                </div>
                <div class="card right" v-on:mouseover="toolHover(5)" v-on:mouseleave="leave">
                    <a href="#tools-5" v-smooth-scroll>
                        <h4>Texto interactivo</h4>
                        <p>{{$store.state.tools[5].mobileText}}</p>
                        <div class="icon">
                            <img :src="require('../assets/images/interactive.png')" class="img-fluid">
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            mainBackground: 'INITIAL-FULL.png',
            showTool: true,
        }
    },
    methods: {
        toolHover(index){
            this.showTool = false
            this.$store.state.tools[index].showImg = true
        },
        leave () {
            this.$store.state.tools.forEach(element => element.showImg = false);
            this.showTool = true
        }
    },
}
</script>
<style scoped lang="scss">
.card a{
    text-decoration: none;
    color: #000;
}
.slide-enter-active,
.slide-leave-active{
  transition-duration: 0.3s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}
.slide-enter{
  opacity: 0;
  transform: translate(100%, 0);
}
.slide-enter-to{
  opacity: 1;
  transform: translate(0%, 0);
}
.slide-leave{
  opacity: 1;
  transform: translate(0%, 0);
}
.slide-leave-to{
  opacity: 0;
  transform: translate(-100%, 0);
}
// .slide-leave-active{
//   opacity: 1;
//   transform: translate(0%, 0);
// }
</style>
<style lang="scss">
    .jabrutouch-img-shadow{
        z-index: 10;
    }
    .jabrutouch-gradient{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 0;
    }
    .app-description .card{
        background: #FFEED9;
        border-radius: 18px;
        padding: 30px;
        border: 0;
        margin-bottom: 50px;
    }
    .app-description .card.left{
        padding-right: 60px;
        margin-right: 40px;
    }
    .app-description .card.right{
        padding-left: 60px;
        margin-left: 40px;
    }
    .app-description .card.bottom{
        padding-top: 60px;
        margin-top: 80px;
    }
    .app-description .card .icon{
        z-index: 99;
        position: absolute;
        width: 100px;
        top: calc(50% - 50px);
        background: #5A57DF;
        height: 100px;
        border-radius: 50px;
        text-align: center;
        line-height: 100px;
    }
    .app-description .card.left .icon{
        right: -50px;
    }
    .app-description .card.right .icon{
        left: -50px;
    }
    .app-description .card.bottom .icon{
        top: -50px;
        left: calc(50% - 50px);
    }
    .frame{
        position: relative;
        min-height: 600px;
        -webkit-filter: drop-shadow(30px 40px 40px rgba(0,0,0,.35));
        filter: drop-shadow(30px 40px 40px rgba(0,0,0,.35));
        border-radius: 60px;
        overflow: hidden;
        background-position: -100%;
        img.phone-menu {
            position: absolute;
            bottom: 20px;
            z-index: -1;
            left: 5%;
            right: 5%;
            width: 90%;
        }
        .img,.tool-img {
            // transition: background-image 0.4s, background-position 0.4s;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            background-position: center;
            background-repeat: no-repeat;
            z-index: -5;
            width: 100%;
            background-size: contain;
        }
        .tool-img{
            z-index: -3;
        }
    }
</style>